<template>
  <div>
    <CRow>
      <CCol>
        <CCard>
          <CCardBody>
            <CRow class="mb-3">
              <CCol md="6">
                <strong>Izvori oglasa</strong>
                <div class="d-flex align-items-center mt-2">
                  <CSwitch class="mr-2" color="info" shape="pill" :checked.sync="crawlerSources.njuskalo" />
                  <span>Njuškalo</span>
                </div>
                <div class="d-flex align-items-center mt-2">
                  <CSwitch class="mr-2" color="info" shape="pill" :checked.sync="crawlerSources.nekretnine" />
                  <span>Nekretnine.hr</span>
                </div>
                <div class="d-flex align-items-center mt-2">
                  <CSwitch class="mr-2" color="info" shape="pill" :checked.sync="crawlerSources.index" />
                  <span>Index Oglasi</span>
                </div>
                <CButton class="mt-3" color="primary" size="sm" :disabled="sourceSettingsSaving || !sourceSettingsChanged" @click="saveCrawlerSources">
                  {{ sourceSettingsSaving ? "Spremanje..." : "Spremi izvore" }}
                </CButton>
                <span v-if="sourceSettingsMessage" class="ml-2" :class="sourceSettingsError ? 'text-danger' : 'text-success'">
                  {{ sourceSettingsMessage }}
                </span>
              </CCol>
            </CRow>
            <CRow>
              <CCol>
                <CButton color="secondary" @click="startScrapeNewAdsJob">Scrape novih</CButton>
              </CCol>
            </CRow>
            <CRow>
              <CCol v-html="scrapeStatus"> </CCol>
            </CRow>
            <CRow>
              <CCol class="text-muted small">Backend: {{ backendRuntimeMarker }}</CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CRow>
      <CCol>
        <CCard>
          <CCardHeader>
            Runovi zadnja 2 dana
            <CButton class="float-right" color="secondary" size="sm" :disabled="runsLoading" @click="loadRuns">
              {{ runsLoading ? "Učitavanje..." : "Osvježi" }}
            </CButton>
          </CCardHeader>
          <CCardBody>
            <p v-if="runsError" class="text-danger mb-0">{{ runsError }}</p>
            <p v-else-if="!runsLoading && runs.length === 0" class="text-muted mb-0">Nema zabilježenih runova u zadnja 2 dana.</p>
            <table v-else class="table table-sm table-striped mb-0">
              <thead>
                <tr>
                  <th>Početak</th>
                  <th>Trajanje</th>
                  <th>Ubačeno oglasa</th>
                  <th>Job</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="run in runs" :key="run.id">
                  <td class="text-nowrap">{{ formatRunStart(run.startedAt) }}</td>
                  <td class="text-nowrap">{{ formatRunDuration(run.durationS) }}</td>
                  <td>
                    <strong>{{ formatInsertedAds(run) }}</strong>
                    <span v-if="formatInsertedBySource(run)" class="text-muted small ml-1">({{ formatInsertedBySource(run) }})</span>
                  </td>
                  <td>{{ formatRunJob(run.job) }}</td>
                  <td :class="runStatusClass(run.status)" :title="run.error || ''">{{ formatRunStatus(run.status) }}</td>
                </tr>
              </tbody>
            </table>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CRow>
      <CCol>
        <CCard>
          <CCardHeader> Log zadnjeg pokretanja </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol>
                <p
                  :class="message.type && message.type === 'error' ? 'text-danger' : message.type === 'info' ? 'text-success' : ''"
                  template
                  v-for="(message, key) in $store.state.messages"
                  :key="key"
                >
                  <span v-html="getDateText(message.date)"> </span>
                  ::
                  <span v-html="message.text"> </span>
                </p>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import moment from "moment";
import { crawlerSourceService, scraperService } from "../services/services";
import {
  formatRunStart,
  formatRunDuration,
  formatInsertedAds,
  formatInsertedBySource,
  formatRunJob,
  formatRunStatus,
} from "../services/scraperRunsFormat";

export default {
  data() {
    return {
      backendRuntimeMarker: "provjera...",
      crawlerSources: { njuskalo: true, nekretnine: false, index: false },
      initialCrawlerSources: { njuskalo: true, nekretnine: false, index: false },
      sourceSettingsSaving: false,
      sourceSettingsMessage: "",
      sourceSettingsError: false,
      runs: [],
      runsLoading: false,
      runsError: "",
    };
  },
  mounted() {
    this.loadCrawlerSources();
    this.loadRuns();
    scraperService
      .getRuntimeMarker()
      .then((response) => {
        this.backendRuntimeMarker = response.body.marker;
      })
      .catch(() => {
        this.backendRuntimeMarker = "marker nije dostupan (stari backend)";
      });
  },
  computed: {
    sourceSettingsChanged() {
      return this.crawlerSources.njuskalo !== this.initialCrawlerSources.njuskalo
        || this.crawlerSources.nekretnine !== this.initialCrawlerSources.nekretnine
        || this.crawlerSources.index !== this.initialCrawlerSources.index;
    },
    scrapeStatus() {
      let errorMessage = this.$store.state.messages.find((m) => m.type === "error");
      if (errorMessage) {
        return moment(errorMessage.date).fromNow() + ": " + errorMessage.text;
      }

      let infoMessage = this.$store.state.messages.find((m) => m.type === "info");
      if (infoMessage) {
        return moment(infoMessage.date).fromNow() + ": " + infoMessage.text;
      }

      let lastMessage = this.$store.state.messages[0];
      if (lastMessage) {
        return moment(lastMessage.date).fromNow() + ": " + lastMessage.text;
      }
      return "";
    },
  },
  methods: {
    formatRunStart,
    formatRunDuration,
    formatInsertedAds,
    formatInsertedBySource,
    formatRunJob,
    formatRunStatus,
    loadRuns() {
      this.runsLoading = true;
      this.runsError = "";
      scraperService
        .getRuns(48)
        .then((response) => {
          this.runs = response.body;
        })
        .catch(() => {
          this.runsError = "Runove nije moguće učitati.";
        })
        .finally(() => {
          this.runsLoading = false;
        });
    },
    runStatusClass(status) {
      if (status === "error" || status === "timeout") {
        return "text-danger";
      }
      if (status === "skipped") {
        return "text-muted";
      }
      return "text-success";
    },
    loadCrawlerSources() {
      crawlerSourceService
        .get()
        .then((response) => {
          this.crawlerSources = { ...response.body };
          this.initialCrawlerSources = { ...response.body };
        })
        .catch(() => {
          this.sourceSettingsError = true;
          this.sourceSettingsMessage = "Izvore nije moguće učitati.";
        });
    },
    saveCrawlerSources() {
      this.sourceSettingsSaving = true;
      this.sourceSettingsMessage = "";
      this.sourceSettingsError = false;
      crawlerSourceService
        .replace(this.crawlerSources)
        .then((response) => {
          this.crawlerSources = { ...response.body };
          this.initialCrawlerSources = { ...response.body };
          this.sourceSettingsMessage = "Izvori su spremljeni.";
        })
        .catch(() => {
          this.sourceSettingsError = true;
          this.sourceSettingsMessage = "Izvore nije moguće spremiti.";
        })
        .finally(() => {
          this.sourceSettingsSaving = false;
        });
    },
    startScrapeNewAdsJob() {
      this.$store.commit("set", ["messages", []]);
      scraperService.startScrapeNewAdsJob(this.$store.state.userAgent, this.$store.state.cookie);
    },
    startScrapeExistingAdsDetailsJob() {
      this.$store.commit("set", ["messages", []]);
      scraperService.startScrapeExistingAdsDetailsJob(this.$store.state.userAgent, this.$store.state.cookie);
    },
    getDateText(date) {
      return moment(date).format("DD.MM. HH:mm:ss");
    },
  },
};
</script>
